/**
 * Подсветка объекта под курсором на холсте — SVG-фильтры, которые вешают на объект:
 *   • красный — ластик: этот объект удалится по клику;
 *   • синий — тянут стрелку комментария: к этому объекту она прицепится.
 *
 * Объект не перекрашивается целиком в пятно: тёмные линии темнеют в тон, белая заливка
 * светлеет в тон, рисунок остаётся виден. Пока ластик включён, у всего холста один
 * курсор — стрелка с красной корзиной, — объекты не подменяют его своими («тянуть», «крестик»).
 * На лист PDF ни фильтры, ни курсор не попадают.
 */
export const ERASE_TINT_ID = "erase-tint";
export const ATTACH_TINT_ID = "attach-tint";

/** Стрелка с корзиной; остриё стрелки — точка клика */
const ERASE_CURSOR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
<path d="M1 1v14l3.6-3.2 2.4 5.4 2.2-1-2.4-5.3H12z" fill="#1d2430" stroke="#fff" stroke-width="1.2" stroke-linejoin="round"/>
<path d="M13.4 14.2l.7 8.3h6.2l.7-8.3z" fill="#e5484d" stroke="#fff" stroke-width="1.1" stroke-linejoin="round"/>
<path d="M12.2 13.6h10M15.6 13.6v-1.6h3.2v1.6" fill="none" stroke="#e5484d" stroke-width="1.6" stroke-linecap="round"/>
</svg>`;

const ERASE_CURSOR = `url("data:image/svg+xml,${encodeURIComponent(ERASE_CURSOR_SVG)}") 1 1, crosshair`;

interface Props {
	/** Ластик включён — весь холст под курсором-ластиком */
	erasing: boolean;
}

export const HoverTints = ({ erasing }: Props) => (
	<defs data-plan-export-exclude>
		<filter id={ERASE_TINT_ID} colorInterpolationFilters="sRGB">
			<feColorMatrix
				type="matrix"
				values="0.3 0 0 0 0.62  0 0.3 0 0 0.05  0 0 0.3 0 0.05  0 0 0 1 0"
			/>
		</filter>
		<filter id={ATTACH_TINT_ID} colorInterpolationFilters="sRGB">
			<feColorMatrix
				type="matrix"
				values="0.3 0 0 0 0.13  0 0.3 0 0 0.3  0 0 0.3 0 0.66  0 0 0 1 0"
			/>
		</filter>
		{/* !important перебивает курсоры, заданные объектам в их собственном style */}
		{erasing && (
			<style>{`.plan-erasing, .plan-erasing * { cursor: ${ERASE_CURSOR} !important; }`}</style>
		)}
	</defs>
);
